module.exports = __webpack_public_path__ + "static/media/people.5177ca63.svg";